<template>
  <div class="pc-sidebar__tools">
    <icon-trash-undo class="pc-layout__sidebar-icon" title="回收站"/>
    <icon-bars class="pc-layout__sidebar-icon" title="管理" @click="showToolsContextmenuHandler"/>
  </div>
</template>

<script>
import IconBars from '@/components/icon/Bars.vue'
import IconTrashUndo from '@/components/icon/TrashUndo.vue'
import { createPopper } from '@popperjs/core'
import { mapMutations } from 'vuex'

export default {
  components: {
    IconBars,
    IconTrashUndo
  },
  methods: {
    ...mapMutations('contextmenu', {
      setVisible: 'SET_VISIBLE',
      setType: 'SET_TYPE'
    }),
    showToolsContextmenuHandler (event) {
      const x = event.clientX
      const y = event.clientY
      const virtualElement = {
        getBoundingClientRect: () => ({
          width: 0,
          height: 0,
          top: y,
          right: x,
          bottom: y,
          left: x
        })
      }

      this.setType('SIDEBAR_TOOLS')
      this.setVisible(true)
      this.$nextTick(() => {
        window.contextmenuPopper = createPopper(virtualElement, window.document.getElementById('pc-contextmenu'), {
          placement: 'bottom-start',
          strategy: 'fixed'
        })
      })
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-sidebar__tools {

}
</style>
